<template>
  <div>
    <v-card-text class="text-center">
      <v-icon size="56" :color="color"> {{ icon }} </v-icon>
    </v-card-text>
    <h1 class="text-center">{{ title }}</h1>
    <v-card-text class="text-center body-1">
      <p>
        {{ text }}
      </p>
      <p v-if="sub">{{ sub }}</p>
      <slot></slot>
    </v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
    sub: {
      type: String,
      required: false,
    },
  },
};
</script>
